/* ==========================================================
   ThirsTee – varukorgslogik (Shopify AJAX Cart API)
   Konfiguration sätts i window.TTCart av snippeten tt-shell.
   ========================================================== */

(function () {
  'use strict';

  var cfg = window.TTCart || {};
  var LOCALE = cfg.locale || 'sv-SE';
  var CURRENCY = cfg.currency || 'SEK';
  var THRESHOLD = typeof cfg.threshold === 'number' ? cfg.threshold : 0;
  var CART_URL = cfg.cartUrl || '/cart';

  var el = {};
  var lastFocus = null;

  /* ---------- hjälpare ---------- */

  function money(cents) {
    try {
      return new Intl.NumberFormat(LOCALE, {
        style: 'currency',
        currency: CURRENCY,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' kr';
    }
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function thumb(url, size) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + size : url + '?width=' + size;
  }

  function cache() {
    el.drawer = document.querySelector('[data-tt-drawer]');
    if (!el.drawer) return false;
    el.panel = el.drawer.querySelector('[data-tt-panel]');
    el.items = el.drawer.querySelector('[data-tt-items]');
    el.empty = el.drawer.querySelector('[data-tt-empty]');
    el.foot = el.drawer.querySelector('[data-tt-foot]');
    el.total = el.drawer.querySelector('[data-tt-total]');
    el.n = el.drawer.querySelector('[data-tt-drawer-count]');
    el.ship = el.drawer.querySelector('[data-tt-ship]');
    el.shipText = el.drawer.querySelector('[data-tt-ship-text]');
    el.shipFill = el.drawer.querySelector('[data-tt-ship-fill]');
    el.shipFlag = el.drawer.querySelector('[data-tt-ship-flag]');
    el.error = el.drawer.querySelector('[data-tt-error]');
    return true;
  }

  /* ---------- öppna / stäng ---------- */

  function open() {
    if (!el.drawer) return;
    lastFocus = document.activeElement;
    el.drawer.classList.add('is-open');
    el.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tt-locked');
    var close = el.drawer.querySelector('[data-tt-close]');
    if (close) close.focus();
  }

  function close() {
    if (!el.drawer) return;
    el.drawer.classList.remove('is-open');
    el.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tt-locked');
    hideError();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showError(msg) {
    if (!el.error) return;
    el.error.textContent = msg;
    el.error.hidden = false;
  }

  function hideError() {
    if (!el.error) return;
    el.error.hidden = true;
    el.error.textContent = '';
  }

  /* ---------- rendering ---------- */

  function badge(count) {
    var nodes = document.querySelectorAll('[data-tt-cart-count]');
    Array.prototype.forEach.call(nodes, function (node) {
      node.textContent = count;
      node.hidden = count < 1;
    });
  }

  function shipping(total) {
    if (!el.ship) return;
    if (THRESHOLD <= 0) {
      el.ship.hidden = true;
      return;
    }
    el.ship.hidden = false;
    var left = THRESHOLD - total;
    var pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));

    if (left > 0) {
      el.shipText.innerHTML = 'Handla för <strong>' + esc(money(left)) + '</strong> mer så bjuder vi på frakten.';
    } else {
      el.shipText.innerHTML = '<strong>Fri frakt</strong> är upplåst. Snyggt slag.';
    }
    el.shipFill.style.width = pct + '%';
    if (el.shipFlag) el.shipFlag.style.left = pct + '%';
  }

  function lineHTML(item, index) {
    var line = index + 1;
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var discounted = item.original_line_price > item.final_line_price;

    return (
      '<article class="tt-line">' +
        '<a class="tt-line__media" href="' + esc(item.url) + '">' +
          (item.featured_image && item.featured_image.url
            ? '<img src="' + esc(thumb(item.featured_image.url, 200)) + '" alt="' + esc(item.featured_image.alt || item.product_title) + '" loading="lazy">'
            : '') +
        '</a>' +
        '<div>' +
          '<a class="tt-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (variant ? '<p class="tt-line__meta">' + esc(variant) + '</p>' : '') +
          '<div class="tt-line__foot">' +
            '<div class="tt-step">' +
              '<button type="button" data-tt-line="' + line + '" data-tt-to="' + (item.quantity - 1) + '" aria-label="Minska antal">&minus;</button>' +
              '<span class="tt-step__n">' + item.quantity + '</span>' +
              '<button type="button" data-tt-line="' + line + '" data-tt-to="' + (item.quantity + 1) + '" aria-label="Öka antal">+</button>' +
            '</div>' +
            '<div class="tt-line__price">' +
              (discounted ? '<span class="tt-line__was">' + esc(money(item.original_line_price)) + '</span>' : '') +
              esc(money(item.final_line_price)) +
            '</div>' +
          '</div>' +
          '<button type="button" class="tt-line__remove" data-tt-line="' + line + '" data-tt-to="0">Ta bort</button>' +
        '</div>' +
      '</article>'
    );
  }

  function render(cart) {
    badge(cart.item_count);
    if (!el.drawer) return;

    if (el.n) el.n.textContent = cart.item_count === 1 ? '1 vara' : cart.item_count + ' varor';

    if (!cart.items.length) {
      el.items.innerHTML = '';
      el.empty.hidden = false;
      el.foot.hidden = true;
      if (el.ship) el.ship.hidden = true;
      return;
    }

    el.empty.hidden = true;
    el.foot.hidden = false;
    el.items.innerHTML = cart.items.map(lineHTML).join('');
    el.total.textContent = money(cart.total_price);
    shipping(cart.total_price);
  }

  /* ---------- nätverk ---------- */

  function fetchCart() {
    return fetch(CART_URL + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json();
    });
  }

  function addItem(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      body: formData
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Kunde inte läggas till.');
        return data;
      });
    });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) {
      return r.json();
    });
  }

  /* ---------- händelser ---------- */

  function bind() {
    // Öppna panelen
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-tt-cart-open]');
      if (opener) {
        e.preventDefault();
        open();
        fetchCart().then(render).catch(function () {});
        return;
      }
      if (e.target.closest('[data-tt-close]')) {
        e.preventDefault();
        close();
      }
    });

    // Escape stänger
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.drawer && el.drawer.classList.contains('is-open')) close();
    });

    // Antal och borttagning i panelen
    if (el.items) {
      el.items.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tt-line]');
        if (!btn) return;
        var line = parseInt(btn.getAttribute('data-tt-line'), 10);
        var to = parseInt(btn.getAttribute('data-tt-to'), 10);
        if (isNaN(line) || isNaN(to) || to < 0) return;

        btn.disabled = true;
        hideError();
        changeLine(line, to)
          .then(render)
          .catch(function () {
            showError('Varukorgen kunde inte uppdateras. Försök igen.');
          });
      });
    }

    // Lägg i varukorgen utan omladdning
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      hideError();

      var button = form.querySelector('[type="submit"]');
      var label = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Lägger till…';
      }

      addItem(new FormData(form))
        .then(function () {
          return fetchCart();
        })
        .then(function (cart) {
          render(cart);
          open();
        })
        .catch(function (err) {
          open();
          showError(err.message || 'Något gick fel. Försök igen.');
        })
        .then(function () {
          if (button) {
            button.disabled = false;
            button.textContent = label;
          }
        });
    });
  }

  function init() {
    if (!cache()) {
      // Ingen panel på sidan – uppdatera ändå räknaren.
      fetchCart().then(function (cart) {
        badge(cart.item_count);
      }).catch(function () {});
      return;
    }
    bind();
    fetchCart().then(render).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
